module.exports = __webpack_public_path__ + "static/media/workPvcCeilings7.f007c66b.jpg";